import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "engagement-service/engagement/broadcasting";

const BASE_SMS_URL = "sms-service/merchant";

export default {
    createBroadcast(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/create", param, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getBroadcasts(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/list/" + param.page, param.payload, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getTargetSegmentOptions() {
        return new Promise((resolve, reject) => {
            api.get("target-segment-service/target-segment/module-options", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getSearchableFields() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/searchable-fields", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    visibility(param, uuid) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/update/visibility/" + uuid, param, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(param);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    delete(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(BASE_SERVICE_URL + "/delete/" + uuid, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    view(uuid) {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/view/" + uuid, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateBroadcast(param, uuid) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/update/" + uuid, param, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(param);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getSmsCount() {
        return new Promise((resolve, reject) => {
            api.post(BASE_SMS_URL + "/sms-count", {}, auth.getHeader())
                .then(response => {
                    //console.log(param);
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getMonthlySmsCount() {
        return new Promise((resolve, reject) => {
            api.post(BASE_SMS_URL + "/sms-count/monthly", {}, auth.getHeader())
                .then(response => {
                    //console.log(param);
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getNotificationCountPerBroadcast(broadcastUuid) {
        return new Promise((resolve, reject) => {
            api.get("notification-service/merchant/notification-count-per-broadcast/" + broadcastUuid, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getSmsCountPerBroadcast(broadcastUuid) {
        return new Promise((resolve, reject) => {
            api.get("sms-service/merchant/sms-count-per-broadcast/" + broadcastUuid, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getSummaryCount(params) { 
        return new Promise((resolve, reject) => { 
            api.post(`sms-service/merchant/broadcast/sms-count`, params, auth.getHeader()) 
                .then(response => { 
                    return resolve(response); 
                }) 
                .catch((status, error) => { 
                    reject(status, error); 
                }); 
        }); 
    } 
};
